<template>
  <div
    v-if="
      (!modalClosed && $store.state.windowSize.w <= Breakpoints.tablet) ||
        (!modalClosed && $store.state.currentBrowser === 'firefox/gecko')
    "
  >
    <FocusTrap>
      <div class="app-overlay" :class="modalClosed && 'app-overlay__closed'">
        <button
          class="app-overlay__close"
          @click="modalClosed = true"
          tabindex="0"
          :aria-label="$t('accessibility.closeAlert')"
        >
          <img src="@/assets/close-x.svg" alt="" />
        </button>
        <div>
          <svg
            class="app-overlay__logo"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 558.6 80.7"
          >
            <path
              d="M367 30.3c0 1.6.6 2.9 1.7 4s3.1 2.4 5.9 3.8c3.8 2 6.6 4 8.3 6 1.7 2 2.5 4.3 2.5 6.9 0 3.8-1.4 6.8-4.2 9-2.8 2.2-6.3 3.3-10.6 3.3-2.5 0-4.7-.3-6.8-.8s-3.6-1.1-4.6-1.7v-8.2c1.3 1.2 3 2.2 5.1 3 2.1.8 4.1 1.2 6.1 1.2 2.2 0 3.9-.4 5.2-1.3 1.3-.8 1.9-2.1 1.9-3.8 0-1.5-.6-2.8-1.9-4.1-1.2-1.2-3.5-2.7-6.8-4.4-3.3-1.7-5.7-3.5-7.3-5.5-1.6-2-2.4-4.3-2.4-7 0-3.6 1.4-6.5 4.2-8.8 2.8-2.3 6.3-3.4 10.6-3.4 1.9 0 3.8.2 5.6.5 1.8.4 3.1.7 4 1.1V28c-1.2-.9-2.6-1.7-4.3-2.2-1.7-.5-3.4-.8-5.1-.8-2.1 0-3.8.5-5.1 1.4-1.3 1.1-2 2.4-2 3.9zm50.8 1.3v31h-7.4v-4.1h-.1c-1 1.4-2.3 2.5-3.9 3.3-1.6.8-3.4 1.2-5.4 1.2-3.6 0-6.3-1-8.2-3.1-1.9-2-2.8-5.2-2.8-9.5V31.6h7.4v18c0 2.6.5 4.6 1.6 5.9 1 1.3 2.6 2 4.7 2s3.7-.7 5-2.2c1.2-1.5 1.9-3.4 1.9-5.7v-18h7.2zm22-.5c.6 0 1.1 0 1.6.1s.9.2 1.2.3v7.4c-.4-.3-.9-.5-1.7-.8-.7-.3-1.6-.4-2.7-.4-1.8 0-3.3.8-4.5 2.3s-1.9 3.8-1.9 7v15.6h-7.3v-31h7.3v4.9h.1c.7-1.7 1.7-3 3-4 1.3-.9 3-1.4 4.9-1.4zm21.5-14.9c.9 0 1.7 0 2.4.1s1.3.2 1.8.4V23c-.2-.1-.7-.3-1.3-.5-.6-.2-1.3-.3-2.1-.3-1.5 0-2.7.5-3.5 1.4s-1.2 2.4-1.2 4.2v3.7h6.9v6h-6.9v25H450v-25h-5.2v-6h5.2v-4.3c0-3.3 1.1-5.9 3.2-8 2-2 4.8-3 8.1-3zm30.9 27v12.1c0 2.9.2 5.4.5 7.3h-7.3l-.4-3.3c-.9 1.2-2.1 2.2-3.6 2.8-1.5.7-3.4 1-5.6 1-2.7 0-5-.8-6.9-2.5-1.8-1.7-2.8-3.9-2.8-6.7 0-3 1.2-5.4 3.5-7.2 2.4-1.8 6.1-3 11.1-3.7l4.4-.5c0-2-.5-3.5-1.4-4.4-1-.9-2.4-1.3-4.3-1.3-2.1 0-4.1.3-5.9.9-1.9.6-3.3 1.4-4.3 2.2v-6.7c1-.5 2.6-1.1 4.7-1.6 2.1-.6 4.3-.8 6.7-.8 3.9 0 6.8 1.1 8.8 3.2 1.8 2.2 2.8 5.2 2.8 9.2zm-10.3 4.6c-3.2.4-5.5 1-6.8 1.9-1.3.9-2 2-2 3.6 0 1.3.4 2.3 1.2 3.1.8.8 1.9 1.1 3.5 1.1 2.3 0 4.1-.7 5.4-2.1 1.3-1.4 2-3.1 2-5.3v-2.7l-3.3.4zm32 9.5c1.1 0 2.3-.3 3.6-.8 1.3-.5 2.5-1.2 3.6-2v6.8c-1.2.7-2.5 1.2-4 1.5-1.5.3-3.1.5-4.9.5-4.6 0-8.3-1.4-11.1-4.3-2.9-2.9-4.3-6.6-4.3-11 0-5 1.5-9.1 4.4-12.3 2.9-3.2 7-4.8 12.4-4.8 1.4 0 2.7.2 4.1.5 1.4.4 2.5.8 3.3 1.2v7c-1.1-.8-2.3-1.5-3.4-1.9-1.2-.5-2.4-.7-3.6-.7-2.9 0-5.2.9-7 2.8-1.8 1.9-2.7 4.4-2.7 7.6 0 3.1.8 5.6 2.5 7.3 1.8 1.7 4.1 2.6 7.1 2.6zm36.5-2.5v6c-1.2.8-2.8 1.4-4.7 1.9-1.9.5-4 .7-6.2.7-4.7 0-8.4-1.4-11-4.2-2.6-2.8-3.9-6.7-3.9-11.7 0-4.8 1.4-8.8 4.2-11.9 2.8-3.1 6.4-4.7 10.6-4.7 4.3 0 7.6 1.3 10 3.9 2.4 2.6 3.6 6.2 3.6 10.9v3.5h-21.2c.3 3.1 1.3 5.3 3 6.5 1.7 1.2 3.8 1.9 6.5 1.9 1.7 0 3.4-.3 5-.8 1.4-.4 2.8-1.1 4.1-2zM545.7 44c0-2.4-.6-4.2-1.7-5.5-1.1-1.3-2.7-1.9-4.7-1.9-1.7 0-3.3.6-4.7 1.9-1.4 1.3-2.3 3.1-2.8 5.5h13.9zm-401-24.6v43.2h-7.5V28.7h-.1l-13.4 33.9h-5L105 28.7h-.1v33.9H98V19.4h10.8l12.4 32h.2l13.1-32h10.2zm6.3 3.3c0-1.2.4-2.2 1.3-3 .9-.8 1.9-1.2 3.1-1.2 1.3 0 2.4.4 3.2 1.3.8.8 1.3 1.8 1.3 3s-.4 2.2-1.3 3c-.9.8-1.9 1.2-3.2 1.2s-2.3-.4-3.1-1.2c-.9-1-1.3-2-1.3-3.1zm8 8.9v31h-7.3v-31h7.3zm22.1 25.7c1.1 0 2.3-.3 3.6-.8 1.3-.5 2.5-1.2 3.6-2v6.8c-1.2.7-2.5 1.2-4 1.5-1.5.3-3.1.5-4.9.5-4.6 0-8.3-1.4-11.1-4.3-2.9-2.9-4.3-6.6-4.3-11 0-5 1.5-9.1 4.4-12.3 2.9-3.2 7-4.8 12.4-4.8 1.4 0 2.7.2 4.1.5 1.4.4 2.5.8 3.3 1.2v7c-1.1-.8-2.3-1.5-3.4-1.9-1.2-.5-2.4-.7-3.6-.7-2.9 0-5.2.9-7 2.8-1.8 1.9-2.7 4.4-2.7 7.6 0 3.1.8 5.6 2.5 7.3 1.9 1.7 4.2 2.6 7.1 2.6zm28-26.2c.6 0 1.1 0 1.6.1s.9.2 1.2.3v7.4c-.4-.3-.9-.5-1.7-.8-.7-.3-1.6-.4-2.7-.4-1.8 0-3.3.8-4.5 2.3-1.2 1.5-1.9 3.8-1.9 7v15.6h-7.3v-31h7.3v4.9h.1c.7-1.7 1.7-3 3-4 1.4-.9 3-1.4 4.9-1.4zm3.1 16.5c0-5.1 1.4-9.2 4.3-12.2s6.9-4.5 12.1-4.5c4.8 0 8.6 1.4 11.3 4.3 2.7 2.9 4.1 6.8 4.1 11.7 0 5-1.4 9-4.3 12s-6.8 4.5-11.8 4.5c-4.8 0-8.6-1.4-11.4-4.2-2.9-2.9-4.3-6.8-4.3-11.6zm7.6-.3c0 3.2.7 5.7 2.2 7.4 1.5 1.7 3.6 2.6 6.3 2.6 2.7 0 4.7-.9 6.1-2.6 1.4-1.7 2.1-4.2 2.1-7.6 0-3.3-.7-5.8-2.2-7.5-1.4-1.7-3.4-2.5-6-2.5-2.7 0-4.7.9-6.2 2.7-1.6 1.7-2.3 4.2-2.3 7.5zm35.1-7.5c0 1 .3 1.9 1 2.5.7.6 2.1 1.3 4.4 2.2 2.9 1.2 5 2.5 6.1 3.9 1.2 1.5 1.8 3.2 1.8 5.3 0 2.9-1.1 5.3-3.4 7-2.2 1.8-5.3 2.7-9.1 2.7-1.3 0-2.7-.2-4.3-.5-1.6-.3-2.9-.7-4-1.2v-7.2c1.3.9 2.8 1.7 4.3 2.2 1.5.5 2.9.8 4.2.8 1.6 0 2.9-.2 3.6-.7s1.2-1.2 1.2-2.3c0-1-.4-1.9-1.2-2.5s-2.4-1.5-4.6-2.4c-2.7-1.1-4.6-2.4-5.7-3.8-1.1-1.4-1.7-3.2-1.7-5.4 0-2.8 1.1-5.1 3.3-6.9 2.2-1.8 5.1-2.7 8.6-2.7 1.1 0 2.3.1 3.6.4 1.3.2 2.5.6 3.4.9V39c-1-.6-2.1-1.2-3.4-1.7-1.3-.5-2.6-.7-3.8-.7-1.4 0-2.5.3-3.2.8-.8.7-1.1 1.4-1.1 2.4zm16.4 7.8c0-5.1 1.4-9.2 4.3-12.2s6.9-4.5 12.1-4.5c4.8 0 8.6 1.4 11.3 4.3 2.7 2.9 4.1 6.8 4.1 11.7 0 5-1.4 9-4.3 12s-6.8 4.5-11.8 4.5c-4.8 0-8.6-1.4-11.4-4.2-2.9-2.9-4.3-6.8-4.3-11.6zm7.6-.3c0 3.2.7 5.7 2.2 7.4 1.5 1.7 3.6 2.6 6.3 2.6 2.7 0 4.7-.9 6.1-2.6 1.4-1.7 2.1-4.2 2.1-7.6 0-3.3-.7-5.8-2.2-7.5-1.4-1.7-3.4-2.5-6-2.5-2.7 0-4.7.9-6.2 2.7-1.6 1.7-2.3 4.2-2.3 7.5zm48.4-9.7h-10.9v25H309v-25h-5.2v-6h5.2v-4.3c0-3.3 1.1-5.9 3.2-8 2.1-2.1 4.8-3.1 8.1-3.1.9 0 1.7 0 2.4.1s1.3.2 1.8.4V23c-.2-.1-.7-.3-1.3-.5-.6-.2-1.3-.3-2.1-.3-1.5 0-2.7.5-3.5 1.4-.8 1-1.2 2.4-1.2 4.2v3.7h10.9v-7l7.3-2.2v9.2h7.4v6h-7.4V52c0 1.9.3 3.3 1 4 .7.8 1.8 1.2 3.3 1.2.4 0 .9-.1 1.5-.3.6-.2 1.1-.4 1.6-.7v6c-.5.3-1.2.5-2.3.7s-2.1.3-3.2.3c-3.1 0-5.4-.8-6.9-2.5-1.5-1.6-2.3-4.1-2.3-7.4V37.6z"
              fill="#77787b"
            />
            <path fill="#f26522" d="M4.3 5h34.2v34.2H4.3z" />
            <path fill="#8dc63f" d="M42.1 5h34.2v34.2H42.1z" />
            <path fill="#00aeef" d="M4.3 42.8h34.2V77H4.3z" />
            <path fill="#ffc20e" d="M42.1 42.8h34.2V77H42.1z" />
          </svg>
          <p
            v-if="$store.state.windowSize.w <= Breakpoints.tablet"
            class="app-overlay__content"
          >
            {{ $t("general.mobileMessage") }}
          </p>
          <p
            v-if="$store.state.currentBrowser === 'firefox/gecko'"
            class="app-overlay__content"
          >
            {{ $t("general.firefoxMessage") }}
          </p>
        </div>
      </div>
    </FocusTrap>
  </div>
</template>
<script>
import { FocusTrap } from "focus-trap-vue";
import Breakpoints from "@/data/breakpoints";

export default {
  components: { FocusTrap },
  data() {
    return {
      modalClosed: false,
      Breakpoints,
    };
  },
};
</script>

<style lang="scss" scoped>
.app-overlay {
  //   display: none;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: $lightGray;
  color: $extraDarkGray;
  &__logo {
    @include breakpoint("desktop") {
      width: 440px;
      max-width: 95%;
    }
    // @include breakpoint("tablet") {
    //   transform: scale(0.7);
    // }
  }
  &__content {
    @include text("body");
    max-width: 475px;
    margin: 0 auto;
    text-align: center;
    color: $extraDarkGray;
    @include breakpoint("mobile") {
      max-width: 100%;
    }
  }
  //   @include breakpoint("tablet") {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &__closed {
    display: none;
  }
  &__close {
    cursor: pointer;
    width: 32px;
    height: 32px;
    position: absolute;
    right: 1rem;
    top: 1rem;
    transition: all 250ms ease;
    padding: 0;
    background: transparent;
    border: none;
    img {
      position: relative;
      transition: all 250ms ease;
      width: 21px;
    }
    &:hover {
      transform: scale(1.1);
    }
  }
  //   }
}
</style>
